import { render, staticRenderFns } from "./category_credit.vue?vue&type=template&id=b9d2f6ec&"
import script from "./category_credit.vue?vue&type=script&lang=js&"
export * from "./category_credit.vue?vue&type=script&lang=js&"
import style0 from "./category_credit.vue?vue&type=style&index=0&id=b9d2f6ec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports